var map = {
	"./copy.png": "5a0e",
	"./facebook.png": "785a",
	"./invitation.png": "1a2f",
	"./key.png": "b7bf",
	"./mail.png": "fd7a",
	"./membership.png": "5043",
	"./payment.png": "5b3f",
	"./phone.png": "3b9b",
	"./play.png": "070a",
	"./search.png": "13b1",
	"./settings.png": "6a88",
	"./twitter.png": "9bde",
	"./user-pink.png": "67e5",
	"./user.png": "0262"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7644";